import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import LoopIcon from '@mui/icons-material/Loop'
import BaseNode from './BaseNode'
import { LoopNodeData } from '../types'

const LoopNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as LoopNodeData
  const subtitle = nodeData.arrayExpression
    ? `Per ${nodeData.itemVariable} in {{ ${nodeData.arrayExpression} }}`
    : 'Set array expression...'

  return (
    <BaseNode
      nodeType="loop"
      icon={<LoopIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top },
        { type: 'source', position: Position.Bottom },
      ]}
    />
  )
}

export default memo(LoopNode)
